import React, { useEffect, useState } from "react";
import basketball from "../images/logo.png";

interface Props {
  setDashboardMode: (value: number) => void;
  dashboardMode: number;
}

const Header: React.FC<Props> = ({ setDashboardMode, dashboardMode }) => {
  return (
    <header className="bg-orange-400 text-black p-4 flex justify-between items-center">
      <div className="flex items-center flex-row">
        <img
          src={basketball}
          alt="basketball"
          className="ml-3 w-7 h-7 inline-block mb-1"
        />
        <h1 className="text-2xl font-bold ml-2">HOOP HELPER</h1>
      </div>
      <nav>
        <label className="inline-flex items-center cursor-pointer">
          <span className="m-3 text-sm font-medium text-black">
            Prediction Mode
          </span>
          <input
            type="checkbox"
            value=""
            className="sr-only peer"
            onClick={() => {
              setTimeout(() => {
                setDashboardMode(1 - dashboardMode);
              }, 300);
            }}
          />
          <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
          <span className="ms-3 text-sm font-medium text-black">
            Analysis Mode
          </span>
        </label>
      </nav>
    </header>
  );
};

export default Header;
